namespace TabAurous.Inventory {
    export interface RepairForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        TransId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        RepairTypeId: Serenity.LookupEditor;
        PartyId: Serenity.ServiceLookupEditor;
        POSCustomerId: Serenity.ServiceLookupEditor;
        TermsId: Serenity.IntegerEditor;
        BillNo: Serenity.StringEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        ItemDetails: RepairItemsEditor;
        TaxDetails: RepairTaxEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        CCNetAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        CCTaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        RoundOff: Serenity.DecimalEditor;
        CCRoundOff: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        CCGrossAmount: Serenity.DecimalEditor;
        Remark: Serenity.TextAreaEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
    }

    export class RepairForm extends Serenity.PrefixedContext {
        static formKey = 'Repair.Repair';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RepairForm.init)  {
                RepairForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.ServiceLookupEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = RepairItemsEditor;
                var w9 = RepairTaxEditor;
                var w10 = s.TextAreaEditor;

                Q.initFormType(RepairForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'TransId', w2,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'RepairTypeId', w4,
                    'PartyId', w5,
                    'POSCustomerId', w5,
                    'TermsId', w3,
                    'BillNo', w2,
                    'CurrencyId', w4,
                    'ExchRate', w6,
                    'ProductItemImage', w7,
                    'ItemDetails', w8,
                    'TaxDetails', w9,
                    'Pieces', w3,
                    'Weight', w6,
                    'NetWeight', w6,
                    'NetAmount', w6,
                    'CCNetAmount', w6,
                    'TaxAmount', w6,
                    'CCTaxAmount', w6,
                    'Discount', w6,
                    'AdditionalCharges', w6,
                    'RoundOff', w6,
                    'CCRoundOff', w6,
                    'GrossAmount', w6,
                    'CCGrossAmount', w6,
                    'Remark', w10,
                    'ShipmentId', w3,
                    'ShipAddressId', w3,
                    'FinancialYearId', w3,
                    'CompanyId', w3
                ]);
            }
        }
    }
}
